import type { CancelTokenSource } from 'axios'
import { defineStore, acceptHMRUpdate } from 'pinia'
import { ref } from 'vue'
import storeConfigs from 'constants/storeConfigs.ts'

type CancelToken = {
	url: string
	token: CancelTokenSource
}

export const useCancelTokensStore = defineStore(
	storeConfigs.cancelTokens.name,
	() => {
		const cancelTokens = ref<CancelToken[]>([])

	function add(data: CancelToken) {
		cancelTokens.value.push(data)
	}
	function remove(url: string) {
		cancelTokens.value = cancelTokens.value.filter(
			(request) => request.url !== url
		)
	}

	function $reset() {
		cancelTokens.value = []
	}

	return {
		cancelTokens,
		add,
		remove,
		$reset,
	}
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useCancelTokensStore, import.meta.hot))
}
